import styled from "styled-components/macro";
import { colors } from "assets/styles/colors";

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background: ${colors.black};
`;
